<div *ngIf="shouldShowErrors()">
  <div class="w-100" *ngFor="let error of listOfErrors()">
    <span class="error err-name text-danger">{{ error }}</span>
  </div>
</div>
